import { BellRing, Calendar, Clock3 } from 'lucide-react'
import React from 'react'

const Schedule = () => {
  return (
    <section className="container mx-auto px-4" aria-labelledby="schedule-title">
      <div className="mb-12 text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-2 text-sm font-semibold uppercase tracking-widest text-blue-700">
          <Clock3 className="h-4 w-4" aria-hidden="true" />
          Coming soon
        </div>
        <h2 id="schedule-title" className="mb-4 text-4xl font-bold text-gray-800 md:text-5xl">
          Event Schedule
        </h2>
        <p className="mx-auto max-w-2xl text-lg text-gray-600 md:text-xl">
          Plan your visit with the complete programme for Open House Day.
        </p>
      </div>

      <div className="mx-auto max-w-4xl overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-blue-100">
        <div className="bg-gradient-to-r from-blue-700 to-cyan-600 px-6 py-8 text-white md:px-10">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-4">
              <div className="rounded-2xl bg-white/15 p-3 ring-1 ring-white/25">
                <Calendar className="h-8 w-8" aria-hidden="true" />
              </div>
              <div>
                <p className="mb-1 text-sm font-medium uppercase tracking-widest text-blue-100">
                  Open House Day
                </p>
                <h3 className="text-2xl font-bold md:text-3xl">October 31, 2026</h3>
              </div>
            </div>
            <span className="w-fit rounded-full bg-amber-300 px-4 py-2 text-sm font-bold text-amber-950">
              Schedule TBA
            </span>
          </div>
        </div>

        <div className="px-6 py-12 text-center md:px-10 md:py-16">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50 text-blue-600 ring-8 ring-blue-50/60">
            <BellRing className="h-9 w-9" aria-hidden="true" />
          </div>
          <h4 className="mb-3 text-2xl font-bold text-gray-800">The full schedule is on its way</h4>
          <p className="mx-auto max-w-xl text-base leading-7 text-gray-600 md:text-lg">
            Session timings, venues, talks, and demonstrations will be announced soon.
            Keep an eye on this page for the latest updates.
          </p>
          <div className="mx-auto mt-8 h-1 w-16 rounded-full bg-cyan-500" />
        </div>
      </div>
    </section>
  )
}

export default Schedule


// import { Calendar } from 'lucide-react'
// import React from 'react'

// const Schedule = () => {
//   return (
//    <>
//     <div className="container mx-auto px-4">
//       <div className="text-center mb-16">
//         <h2 className="text-5xl font-bold text-gray-800 mb-6">Event Schedule</h2>
//         <p className="text-xl text-gray-600">Plan your visit with our detailed schedule</p>
//       </div>

//       <div className="max-w-4xl mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl p-8">
//           <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
//             <Calendar className="w-8 h-8 text-blue-600" />
//             Open House Day - October 31, 2026
//           </h3>
          
//           {/* <div className="space-y-6">
//             <div className="pt-4">
//               <h4 className="text-lg font-semibold text-gray-700 mb-4 border-b-2 border-blue-200 pb-2">
//                 Morning Session
//               </h4>
              
//               <div className="space-y-3">
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       8:00 AM – 9:00 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Registration</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       09:15 AM – 09:20 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                                 <div className="mx-auto max-w-4xl overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-blue-100">
//                                   <div className="bg-gradient-to-r from-blue-700 to-cyan-600 px-6 py-8 text-white md:px-10">
//                                     <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
//                                       <div className="flex items-start gap-4">
//                                         <div className="rounded-2xl bg-white/15 p-3 ring-1 ring-white/25">
//                                           <Calendar className="h-8 w-8" aria-hidden="true" />
//                                         </div>
//                                         <div>
//                                           <p className="mb-1 text-sm font-medium uppercase tracking-widest text-blue-100">
//                                             Open House Day
//                                           </p>
//                                           <h3 className="text-2xl font-bold md:text-3xl">October 31, 2026</h3>
//                                         </div>
//                                       </div>
//                                       <span className="w-fit rounded-full bg-amber-300 px-4 py-2 text-sm font-bold text-amber-950">
//                                         Schedule TBA
//                                       </span>
//                                     </div>
//                                   </div>

//                                   <div className="px-6 py-12 text-center md:px-10 md:py-16">
//                                     <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50 text-blue-600 ring-8 ring-blue-50/60">
//                                       <BellRing className="h-9 w-9" aria-hidden="true" />
//                                     </div>
//                                     <h4 className="mb-3 text-2xl font-bold text-gray-800">The full schedule is on its way</h4>
//                                     <p className="mx-auto max-w-xl text-base leading-7 text-gray-600 md:text-lg">
//                                       Session timings, venues, talks, and demonstrations will be announced soon.
//                                       Keep an eye on this page for the latest updates.
//                                     </p>
//                                     <div className="mx-auto mt-8 h-1 w-16 rounded-full bg-cyan-500" />
//                                   </div>
//                                 </div>
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Lamp lighting ceremony / Saraswati Vandana</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       09:30 AM – 09:35 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Inauguration by Director, IIT Delhi</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       09:35 AM – 10:05 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">What makes S&T Work (or not!)-Prof. Ashutosh Sharma, IIT Kanpur, Padmashree</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       10:10 AM – 10:25 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800"> AI, Robotics and Future of Manufacturing – Prof. Sunil Jha, Mechanical Engineering, IITD</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       10:25 AM – 10:40 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Opportunities for contributing to the Indian Biotech Ecosystem – Anurag S. Rathore, Chemical Engineering, IITD</h4>
//                 </div>
                
//                 <div className="schedule-item bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                       10:40 AM – 10:45 AM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">National Anthem</h4>
//                 </div>
//               </div>
//             </div>
            
//             <div className="pt-4">
//               <h4 className="text-lg font-semibold text-gray-700 mb-4 border-b-2 border-green-200 pb-2">
//                 Mid-day Session
//               </h4>
              
//               <div className="space-y-3">
//                 <div className="schedule-item bg-green-50 p-4 rounded-lg border-l-4 border-green-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
//                       11:00 AM – 2:30 PM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       LHC & Blocks
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Visit to Exhibits & Demonstrations</h4>
//                 </div>
                
//                 <div className="schedule-item bg-green-50 p-4 rounded-lg border-l-4 border-green-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
//                       1:00 PM – 2:00 PM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Various locations
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Lunch</h4>
//                 </div>
//               </div>
//             </div>
            
//             <div className="pt-4">
//               <h4 className="text-lg font-semibold text-gray-700 mb-4 border-b-2 border-purple-200 pb-2">
//                 Afternoon Session
//               </h4>
              
//               <div className="space-y-3">
//                 <div className="schedule-item bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
//                       2:00 PM – 3:30 PM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       LHC
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Thematic sessions</h4>
//                 </div>
                
//                 <div className="schedule-item bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
//                       3:30 PM – 4:00 PM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Closing ceremony and Awards</h4>
//                 </div>
                
//                 <div className="schedule-item bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500 hover:shadow-md transition-all duration-300">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="time-badge px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
//                       4:00 PM – 4:05 PM
//                     </span>
//                     <span className="hall-badge px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
//                       Dogra Hall
//                     </span>
//                   </div>
//                   <h4 className="font-semibold text-lg text-gray-800">Vote of Thanks by Asso Dean (R&D)</h4>
//                 </div>
//               </div>
//             </div>
//           </div> */}

//           TBA
//         </div>
//       </div>
//     </div>
//    </>
//   )
// }

// export default Schedule